import type { CSSProperties, FC } from "react";
import styles from "../index.less";
import React, { useState, useMemo } from "react";
import { Popover } from "antd";
import moment from "moment";

const b = new Array(20).fill(1).map(item => (Date.now() - parseInt(String(Math.random() * 1000 * 60 * 20), 10))).sort((a, b) => (a - b));
/** 计算距离父元素左侧的位置 */
const leftPosition = (distance: number, size: number) => {
    return size / distance * 96 + '%';
};

type Props = {
    style?: CSSProperties
    runCodes: API.runCodesTimeline[]
    reply: string
}

/** 时间轴插件 */
const Timeline: FC<Props> = ({ style, runCodes, reply }) => {
    const [selectTimeIndex, setSelectTimeIndex] = useState<number>(-1);
    const data = useMemo(() => {
        const last = runCodes[runCodes.length - 1];
        const distance = last.timestamp - runCodes[0].timestamp;
        return [distance, runCodes[0].timestamp];
    }, [runCodes]);
    return (
        <div style={{width: '100%'}}>
            <div className={styles.timeline}>
                {runCodes.map((item, index) => (
                    <Popover key={item.timestamp} content={moment(item.timestamp).format('YYYY-MM-DD HH:mm:ss')}>
                        <span onClick={() => setSelectTimeIndex(index)} style={{ left: leftPosition(data[0], item.timestamp - data[1]) }} className={`${styles.circle} ${index === selectTimeIndex ? styles['select-circle'] : ''}`} />
                    </Popover>
                ))}
                <Popover key={-1} content="最终结果">
                    <span onClick={() => setSelectTimeIndex(-1)} style={{ border: '1px solid #1dce27', left: '98%' }} className={`${styles.circle} ${selectTimeIndex === -1 ? styles['select-circle-result'] : ''}`} />
                </Popover>
            </div>
            <div style={{ width: '500px', margin: '20px auto' }}>
                <pre style={{ whiteSpace: 'pre-wrap', wordWrap: 'break-word' }}>{selectTimeIndex === -1 ? reply: runCodes[selectTimeIndex].func}</pre>
            </div>
        </div>
    );
};

export default Timeline;